import { render } from "./NewPackagesComponent.vue?vue&type=template&id=02faf42b&scoped=true"
import script from "./NewPackagesComponent.vue?vue&type=script&lang=js"
export * from "./NewPackagesComponent.vue?vue&type=script&lang=js"

import "./NewPackagesComponent.vue?vue&type=style&index=0&id=02faf42b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02faf42b"]])

export default __exports__